import Core from "@/modules/core/service/Core";
import Site from "@/modules/msd/unit/service/Site";

export default {
    data: () => ({
        type: null,
    }),

    mounted() {
        this.type = this.spec.type;
    },

    watch: {
        spec () {
            this.type = this.spec.type;
        }
    },

    methods: {
        onSave () {
            this.$refs.form.validate ();
            Site.update.spec(this.siteId, { specification: this.spec, tzb: this.tzb}).then(() => {
                Core.message.alert.save(this);
            });
        },

        onType () {
            if (this.type.id !== this.spec.type.id) {
                if (this.type.groupId !== this.spec.type.groupId) {
                    this.updateType();
                } else {
                    this.spec.type = this.type;
                }
            }
        },

        updateType () {
            const query = this.$t("unit.type.change.query");
            const text  = this.$t("unit.type.change.text", [ this.spec.type.name, this.type.name ]);

            Core.message.confirm(this, query, text, Core.message.Default, (confirmed) => {
                if (confirmed) {
                    this.spec.type = this.type;
                    Site.update.type(this.siteId, this.spec.type.id).then(data => {
                        this.$emit("type", data);
                        Core.fire.saved(this, data)
                    });
                }
            });
        },

        /**
         * Changes the site type always through `PUT /api/site/{id}/type` (HCIT-943): the specification save of
         * escalators does not store the type (HCIT-937 W6), so also a change within the group (escalator, moving
         * walk) needs the type endpoint. Every change is confirmed; cancelling restores the selection.
         */
        onTypeChanged () {
            if (!this.type || !this.spec.type || this.type.id === this.spec.type.id) {
                return;
            }

            // the dialog reloads the site after the change, so unsaved input of the specification is lost: also a
            // change within the group is confirmed
            const query = this.$t("unit.type.change.query");
            const text  = this.type.groupId === this.spec.type.groupId
                ? this.$t("unit.type.change.sameGroup", [ this.spec.type.name, this.type.name ])
                : this.$t("unit.type.change.text", [ this.spec.type.name, this.type.name ]);

            Core.message.confirm(this, query, text, Core.message.Default, (confirmed) => {
                if (confirmed) {
                    this.storeType();
                } else {
                    this.type = this.spec.type;
                }
            });
        },

        storeType () {
            const type = this.type;
            Site.update.type(this.siteId, type.id).then(data => {
                this.spec.type = type;
                this.$emit("type", data);
                Core.fire.saved(this, data);
            });
        },

        checkInteger ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if (keyCode < 48 || keyCode > 57) {
                $event.preventDefault();
            }
        },
    }
}